export const ReadyState = Object.freeze({
  UNINSTANTIATED: -1,
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
})

/**
 * @enum {string} EventTypes
 */
export const EventTypes = Object.freeze({
  CONNECT: 'connect',
  FILE_Prefix: 'FILE:',
  FILE_ADD: 'FILE:ADD',
  FILE_DELETE: 'FILE:DELETE',
  FILES_SEEN: 'FILES:SEEN',
  FILE_UPDATED: 'FILE:UPDATED',
  FILES_DELETE: 'FILE:DELETE:MULTIPLE',
  FILES_UPDATE: 'FILE:UPDATE:MULTIPLE',
  FILE_THUMBNAIL_DONE: 'FILE:THUMBNAIL:DONE',
  FILE_THUMBNAIL_DONE_DMS: 'FILE:THUMBNAIL:DONE:DMS',
  FILE_IMAGE_STATS_DMS: 'FILE:IMAGE_STATS:DMS',
  PDF_UPDATED: 'PDF:UPDATED',

  NOTIFICATION_NEW: 'NOTIFICATION:NEW',
  NOTIFICATION_COUNT: 'NOTIFICATION:COUNT',

  TAG_Prefix: 'TAG:',
  TAG_CREATE: 'TAG:CREATE',
  TAG_UPDATE: 'TAG:UPDATE',
  TAG_DELETE: 'TAG:DELETE',

  ORDER_DELIVERY_NOTE_CREATED: 'ORDER:DELIVERY_NOTE_CREATED',
  ORDER_INVOICE_CREATED: 'ORDER:INVOICE_CREATED',

  ECOMMERCE_ORDER_CREATED: 'ECOMMERCE:ORDER_CREATED',
  CLEVERREACH_SYNCHED: 'CLEVERREACH:SYNCHED',
  CUSTOMER_IMPORT: 'CUSTOMER:IMPORT',
  SUPPLIER_IMPORT: 'SUPPLIER:IMPORT',
  MASS_IMPORT_JOB_STATUS: 'MASS_IMPORT:JOB_STATUS',

  DATEV_TRANSFER_JOB_Prefix: 'DATEV_TRANSFER_JOB:',
  DATEV_TRANSFER_JOB_CREATED: 'DATEV_TRANSFER_JOB:CREATE',
  DATEV_TRANSFER_JOB_UPDATE: 'DATEV_TRANSFER_JOB:UPDATE',
  DATEV_TRANSFER_JOB_COMPLETE: 'DATEV_TRANSFER_JOB:COMPLETE',

  PAYMENT_PROVIDER_Prefix: 'PAYMENT_PROVIDER:',
  PAYMENT_PROVIDER_ACCOUNT_UPDATED: 'PAYMENT_PROVIDER:ACCOUNT_UPDATED',
  PAYMENT_PROVIDER_ACCOUNT_DELETED: 'PAYMENT_PROVIDER:ACCOUNT_DELETED',

  COLLABORATION_UPDATED: 'COLLABORATION:UPDATED',
  COLLABORATION_STATUS_CHANGED: 'COLLABORATION:STATUS:CHANGED',

  TODO_CRUD: 'TODO:CRUD',

  TENANT_INFO_REFRESH: 'TENANT:INFO:REFRESH',
  USER_INFO_REFRESH: 'USER:INFO:REFRESH',

  EXPENSE_ANALYSED: 'EXPENSE:ANALYSED',
  EXPENSE_ITEM_UPDATED: 'EXPENSE:ITEM:UPDATED',
  REVENUE_ANALYSED: 'REVENUE:ANALYSED',
  REVENUE_ITEM_UPDATED: 'REVENUE:ITEM:UPDATED',
  FILE_ANALYZED: 'FILE:ANALYSED',
  CUSTOMER_ISSUE_UPDATED: 'MELDUNG:UPDATED',
  NO_ANALYSE_RESULT: 'NO:ANALYSE:RESULT',

  ZREPORT_LIST_UPDATED: 'ZREPORT:LISTS:UPDATED',
  DSFINVK_LIST_UPDATED: 'DSFINVK:LISTS:UPDATED',

  TOKEN_REFRESH: 'TOKEN:REFRESH',

  INVOICE_SYNC_LOCKED: 'INVOICE:SYNC:LOCKED',
  INVOICE_ITEM_UPDATED: 'INVOICE:ITEM:UPDATED',
  EMAIL_OAUTH_FAILED: 'EMAIL:OAUTH:FAILED',
  EMAIL_ACCOUNT_UPDATED: 'EMAIL:ACCOUNT:UPDATED',

  AI_CHAT_RESPONSE: 'AI:CHAT:RESPONSE',
  ACCESS_UPDATED: 'ACCESS:UPDATED',
  BANKING_BOOKINGS_UPDATED: 'BANKING:BOOKINGS:UPDATED',
  TENANT_RESTORE_LOG: 'TENANT:RESTORE:LOG',
  TENANT_RESTORE_STATUS: 'TENANT:RESTORE:STATUS',
})

/**
 * @typedef { Object} WebNotificationBaseMessage
 * @property {string|number} id - Notification ID
 * @property {Date|string} createdAt - Creation timestamp
 * @property {Date|string|null} readDate - Read timestamp (null if unread)
 * @property {ToastOption['icon']} icon - Icon identifier from notification template
 * @property {string} [link] - URL link for the notification
 * @property {boolean} [autoDismiss] - Whether notification auto-dismisses
 * @property {Object} metaData - Additional metadata for the notification
 * @property {string} [text] - Notification text content (if template body is string)
 */

/**
 * @typedef { Record<string, any> & WebNotificationBaseMessage} WebNotificationMessage
 */
